import { ScopeRestrictionDTO } from "../DTO/scopeRestrictionDTO";

export class ScopeRestriction{
    public id!: string;
    public name!: string;

    public static mapFromDTO(param:ScopeRestrictionDTO):ScopeRestriction{ 
        if (!param) throw new Error("parameter is null")
        let obj = new ScopeRestriction();
        try
        {
            obj.id = param.id;
            obj.name = param.name;
        }
        catch(e)
        {
            console.log(e);
            
        }
        return obj;
    }

    public static mapToDTO(param:ScopeRestriction):ScopeRestrictionDTO{ 
        if (!param) throw new Error("parameter is null")
        let dto = new ScopeRestrictionDTO();
        try
        {
            dto.id = param.id;
            dto.name = param.name;
        }
        catch(e)
        {
            console.log(e);
            
        }
        return dto;
    }
}